<div class="container" [attr.data-size]="size()">
  <label class="search">
    <i class="icon icon-search-outline"></i>

    <button
      #searchButton
      class="search__button"
      [ngClass]="{ hidden: !buttonLabel() }"
      (click)="buttonClick.emit($event)"
    >
      <span class="search__button_label">{{ buttonLabel() }}</span>
    </button>

    @let buttonWidth = buttonLabel() ? searchButton.clientWidth + 30 : null;
    <input
      type="text"
      class="search__control"
      [style.padding-right.px]="buttonWidth"
      [value]="value()"
      [placeholder]="placeholder()"
      [disabled]="isDisabled()"
      (blur)="onTouch?.()"
      (input)="onSearchChange($event)"
    />
  </label>
</div>
